import { render, staticRenderFns } from "./conf_join_table.vue?vue&type=template&id=6d82d783&scoped=true&"
import script from "./conf_join_table.vue?vue&type=script&lang=js&"
export * from "./conf_join_table.vue?vue&type=script&lang=js&"
import style0 from "./conf_join_table.vue?vue&type=style&index=0&id=6d82d783&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d82d783",
  null
  
)

export default component.exports